import { SKIPPED_CARD_ERROR_PREFIX } from "@juristic/types/models/chat";
import { isToolUIPart } from "ai";
const ENDED_STATUSES = new Set([
    "stopped",
    "error",
    "interrupted"
]);
export function findCardInterruption(message, toolCallId) {
    const failed = message.parts.filter(isToolUIPart).find((part)=>part.toolCallId === toolCallId && part.state === "output-error");
    if (failed?.state === "output-error" && failed.errorText.startsWith(SKIPPED_CARD_ERROR_PREFIX)) {
        return "skipped";
    }
    return failed !== undefined || ENDED_STATUSES.has(message.metadata?.status);
}
export function interruptionKey(interruption) {
    return interruption === "skipped" ? "chat.card.skipped" : "chat.card.interrupted";
}
